import script from "./CofigurableButtonContent5Component.vue?vue&type=script&setup=true&lang=js"
export * from "./CofigurableButtonContent5Component.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__